import styled from '@emotion/styled';
import { switchProp } from 'styled-tools';
import { M100RichTextLayout } from '~/lib/data-contract';
import { breakpoints } from '~/theme';
import { getColumn, getGutter } from '~/theme/lib/grid';

export type StyledM100RichTextModuleContainerProps = {
	layout?: M100RichTextLayout;
};

export const StyledM100RichText = styled.div<StyledM100RichTextModuleContainerProps>(
	{
		display: 'grid',
		columnGap: getGutter(),
		position: 'relative',
	},
	switchProp('layout', {
		split: {
			[breakpoints.md]: {
				gridTemplateColumns: `calc(${getColumn(3)} + ${getGutter()}) ${getColumn(7)}`,
			},

			[breakpoints.lg]: {
				gridTemplateColumns: `${getColumn(3)} ${getColumn(6, true)}`,
				columnGap: getColumn(1),
			},
		},
		left: () => ({
			[breakpoints.md]: {
				gridTemplateColumns: `${getColumn(8)} 1fr`,

				'> *': {
					gridColumnStart: 1,
				},
			},

			[breakpoints.lg]: {
				gridTemplateColumns: `${getColumn(6)} 1fr`,
			},
		}),
		right: () => ({
			[breakpoints.md]: {
				gridTemplateColumns: `${getColumn(2)} ${getColumn(8, true)}`,

				'> *': {
					gridColumnStart: 2,
				},
			},

			[breakpoints.lg]: {
				gridTemplateColumns: `${getColumn(3)} ${getColumn(5, true)} ${getColumn(1)}`,
			},
		}),
		center: () => ({
			[breakpoints.md]: {
				gridTemplateColumns: `calc(${getColumn(1)} + ${getGutter()} / 2) ${getColumn(8, true)} ${getColumn(1)}`,

				'> *': {
					gridColumnStart: 2,
				},
			},

			[breakpoints.lg]: {
				gridTemplateColumns: `${getColumn(2, true)} ${getColumn(6, true)} ${getColumn(2)}`,
			},
		}),
	}),
);
